import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getItemTrackingCollection,
    ItemTrackingCollectionParam,
    ItemTrackingCollectionResult,
} from "@tKgpco/Services/ItemTrackingService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ItemTrackingCollectionParam, ItemTrackingCollectionResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/ItemTracking/BeginLoadItemTrackingCollection",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getItemTrackingCollection(props.parameter);
};

export const DispatchCompleteItemTrackingCollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/ItemTracking/CompleteLoadItemTrackingCollection",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteItemTrackingCollection];

export const loadItemTrackingCollection = createHandlerChainRunner(chain, "loadItemTrackingCollection");
export default loadItemTrackingCollection;
